import { Component } from '@angular/core';

@Component({
  selector: 'app-help-menu',
  standalone: true,
  imports: [],
  templateUrl: './help-menu.component.html',
  styleUrl: './help-menu.component.css'
})
export class HelpMenuComponent {

}
